import InfoIcon from "@mui/icons-material/Info";
import { Tooltip, IconButton } from "@mui/material";
import { useThemes } from "../../../components/Theme/theme";

type InfoTooltipProps = {
  title: string;
  disabled?: boolean;
};

export const InfoTooltip = ({ title, disabled = false }: InfoTooltipProps) => {
  const Theme = useThemes();

  return (
    <Tooltip
      arrow
      placement="right"
      title={
        <div style={{ whiteSpace: "pre-line", fontSize: 13, margin: 0, padding: 0, lineHeight: 1.4 }}>
          {title?.trim?.() ?? title}
        </div>
      }
    >
      <IconButton
        size="small"
        disabled={disabled}
        sx={{
          p: 0,
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        <InfoIcon
          sx={{
            fontSize: 25,
            color: disabled
              ? Theme.theme.palette.action.disabled
              : Theme.theme.palette.primary.main,
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;